import * as Cesium from "cesium";
import React from "react";
import useViewerStore from "../stores/useViewerStore";


export default function useBaseModel() {
  const { baseModel, viewer } = useViewerStore();

  React.useEffect(() => {
    if (!baseModel || !viewer) return;
    const { path, adjustHeight } = baseModel;
    Cesium.Cesium3DTileset.fromUrl(path, {
      skipLevelOfDetail: true,
      baseScreenSpaceError: 1024,
      skipScreenSpaceErrorFactor: 16,
      skipLevels: 1,
      immediatelyLoadDesiredLevelOfDetail: false,
      loadSiblings: false,
      cullWithChildrenBounds: true,
    }).then((ts) => {
      const tilesetCenter = ts.boundingSphere.center;
      const tilesetCenterCartographic =
        Cesium.Cartographic.fromCartesian(tilesetCenter);
      const adjustedHeight =
        tilesetCenterCartographic.height + (adjustHeight ?? 0);
      // const adjustedHeight = tilesetCenterCartographic.height;
      const newCenter = Cesium.Cartesian3.fromRadians(
        tilesetCenterCartographic.longitude,
        tilesetCenterCartographic.latitude,
        adjustedHeight,
      );
      const translation = Cesium.Cartesian3.subtract(
        newCenter,
        tilesetCenter,
        new Cesium.Cartesian3(),
      );
      // eslint-disable-next-line no-param-reassign
      ts.modelMatrix = Cesium.Matrix4.fromTranslation(
        translation,
        ts.modelMatrix,
      );
      viewer.scene.primitives.add(ts);
    });
  }, [baseModel, viewer]);
}
